import { useEffect, useMemo, useTransition } from 'react';
import { useRecoilValue } from 'recoil';

import { useSyncCalEventsApi } from './useSyncCalEventsApi';
import { syncedDatesState } from '../recoil';
import { useSyncTodosApi } from './useSyncTodosApi';
import { useSyncMetricsApi } from './useSyncMetricsApi';

// Sync processes on the first render of the app
export const useSyncOnFirstRender = () => {
  const [isPending, startTransition] = useTransition();
  const { syncAllCalendarEvents, subscribeToCalendarWatches } = useSyncCalEventsApi();
  const { syncAllTodoTasks, subscribeToTodoWatches } = useSyncTodosApi();
  const { syncWearableData } = useSyncMetricsApi();

  const syncedDates = useRecoilValue(syncedDatesState);

  const { startTime, endTime } = useMemo(() => {
    const startTime = syncedDates[0].startOf('day').toISOString();
    const endTime = syncedDates[syncedDates.length - 1].endOf('day').toISOString();

    return { startTime, endTime };
  }, [syncedDates]);

  // Sync calendar events on the first render of the app
  useEffect(() => {
    startTransition(() => {
      syncAllCalendarEvents(startTime, endTime);
    });
  }, [syncAllCalendarEvents, startTime, endTime]);

  // Sync todo tasks on the first render of the app
  useEffect(() => {
    startTransition(() => {
      syncAllTodoTasks();
    });
  }, [syncAllTodoTasks]);

  // Sync wearable data on the first render of the app
  useEffect(() => {
    startTransition(() => {
      syncWearableData();
    });
  }, [syncWearableData]);

  // Subscribe to calendar watches on the first render of the app
  useEffect(() => {
    startTransition(() => {
      subscribeToCalendarWatches();
    });
  }, [subscribeToCalendarWatches]);

  // Subscribe to todo watches on the first render of the app
  useEffect(() => {
    startTransition(() => {
      subscribeToTodoWatches();
    });
  }, [subscribeToTodoWatches]);

  return { isPending };
};
